module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-8.99921b7f.png";